import React from 'react';
import { WithWebHeaderProps } from '@24i/nxg-sdk-smartott/src/navigation/components/withWebHeader/types';
import { ModularSubscriptionsElements } from '../../../../context/SubscriptionsHandlerProvider/types';
import View from './View/index.web';
import { useViewModel } from './viewModel/index.web';

export const StripePaymentMethod: ModularSubscriptionsElements['PaymentMethodScreen'] = {
    Main: (props: WithWebHeaderProps) => {
        const viewModelProps = useViewModel(props);
        return <View {...viewModelProps} />;
    },
    View,
};
